import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {DriverStateType, initialDriverState, PageKey} from '../@contexts'


export const actionTypes = {
    MarkPageAsSeen: '[MARK_PAGE_AS_SEEN] Action',
    ResetTour: '[RESET_TOUR] Action'
}

export const actions = {
    markPageAsSeen: (page: PageKey) => ({
        type: actionTypes.MarkPageAsSeen,
        payload: page
    }),
    resetTour: () => ({ type: actionTypes.ResetTour })
}


export const reducer = persistReducer(
    {
        storage,
        key: 'v100-demo1-driver',
        whitelist: ['pages'],
        version: 1,
    },
    (state: DriverStateType = initialDriverState, action: any) => {
        switch (action.type) {
            case actionTypes.MarkPageAsSeen:
                return {
                    ...state,
                    pages: {
                        ...state.pages,
                        [action.payload]: true
                    }
                }

            case actionTypes.ResetTour:
                return initialDriverState

            default:
                return state
        }
    },
)